module.exports = __webpack_public_path__ + "img/tram-red.31f3e6e3.svg";